<div class="side-menu-desktop-root">
  <div class="upper-part">
    <div class="epson-logo-size-setter">
      <app-epson-logo animateOnHover></app-epson-logo>
    </div>
    <app-sidemenu-item (click)="menuTrigger.toggleMenu();helpMenuTrigger.closeMenu();" id="lnr-icon-menu" icon="menu" [isMobile]="false">
      <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"></div>
    </app-sidemenu-item>

    <ng-container *ngFor="let nav of flatNavItems">
      <app-sidemenu-item id="{{'lnr-sidemenuitem-'+nav[0].replace('-', '')}}"
                         (click)="onRoute(nav[0])"
                         icon="{{ nav[1] }}"
                         [isMobile]="false">
        {{ nav[2] }}
      </app-sidemenu-item>
    </ng-container>

    <app-sidemenu-item (click)="helpMenuTrigger.toggleMenu();menuTrigger.closeMenu();" id="lnr-icon-help" icon="help" [isMobile]="false">
      <div #helpMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="helpMenu"></div>
      {{ helpMenuItem[2] }}
    </app-sidemenu-item>

    <mat-menu #helpMenu="matMenu" class="help-menu-desktop-overlay-root" hasBackdrop="false">
      <div class="title"
           (click)="$event.stopPropagation();$event.preventDefault();">
        <mat-icon class="remove-image"
                  (click)="helpMenuTrigger.closeMenu()">
          close
        </mat-icon>
      </div>
      <ng-container *ngFor="let nav of expandedHelpItems">
        <app-sidemenu-item id="lnr-sidemenuitem-{{nav[0]}}"
                           (click)="onRoute(nav[0])"
                           [isMobile]="false"
                           [expandRow]="true">
          {{ nav[2] }}
        </app-sidemenu-item>
      </ng-container>
    </mat-menu>

    <mat-menu #menu="matMenu" class="side-menu-desktop-overlay-root" hasBackdrop="false">
      <div class="title"
           (click)="$event.stopPropagation();$event.preventDefault();">
        Menu
        <mat-icon class="remove-image"
                  (click)="menuTrigger.closeMenu()">
          close
        </mat-icon>
      </div>
      <ng-container *ngFor="let nav of expandedNavItems">
        <app-sidemenu-item id="lnr-sidemenuitem-{{nav[0]}}"
                           (click)="onRoute(nav[0])"
                           icon="{{ nav[1] }}"
                           [isMobile]="false"
                           [expandRow]="true">
          {{ nav[2] }}
        </app-sidemenu-item>
      </ng-container>
    </mat-menu>
  </div>
  <app-epson-powered></app-epson-powered>
</div>
